"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var ZoomOutMap = function ZoomOutMap(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? '20' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '20' : _ref$height;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 19 19",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.60352 15.875V11.75H4.7285V13.9596L7.24102 11.4471L8.03138 12.2375L5.51887 14.75H7.7285V15.875H3.60352ZM12.2285 15.875V14.75H14.4381L11.9256 12.2375L12.716 11.4471L15.2285 13.9596V11.75H16.3535V15.875H12.2285ZM7.24102 7.55287L4.7285 5.04035V7.24998H3.60352V3.125H7.7285V4.24998H5.51887L8.03138 6.7625L7.24102 7.55287ZM12.716 7.55287L11.9256 6.7625L14.4381 4.24998H12.2285V3.125H16.3535V7.24998H15.2285V5.04035L12.716 7.55287Z",
    fill: "#75767A",
    fillOpacity: 1
  }));
};
ZoomOutMap.propTypes = {
  width: _propTypes.default.string,
  height: _propTypes.default.string
};
ZoomOutMap.defaultProps = {
  width: 24,
  height: 24
};
var _default = ZoomOutMap;
exports.default = _default;